import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { InstitutionGroupDetail } from '@/internal-app/pages/institutionGroups'
import ErrorBoundary from '@/components/ErrorBoundary'
import LoadingIndicator from '@/components/LoadingIndicator'
import { ValidationBoundary, ValidationState } from '@/components/validation'

export class InstitutionGroupDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = { ...props.institutionGroup }
  }

  renderBody () {
    if (this.props.loading) { return <LoadingIndicator /> }
    return (
      <InstitutionGroupDetail
        {...this.state}
        disabled={this.props.disabled}
        onNameChange={name => this.setState({ name })}
        onLatinNameChange={latinName => this.setState({ latinName })}
        onMembersChange={members => this.setState({ members })}
      />
    )
  }
  render () {
    const { loading, disabled } = this.props
    return (
      <ValidationBoundary>
        <BasicHeader title='' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            {this.renderBody()}
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...this.props} onAction={() => this.props.onAction(this.state)} disabled={loading || !isValid || disabled} />
        } />
      </ValidationBoundary>
    )
  }
}



// WEBPACK FOOTER //
// ./src/dialogs/institutionGroup/dialog.js